import { useT } from '../../i18n'

// Findings #223: pages for the results table. CSV and "Publicar" keep every row.

export const DEFAULT_REPORT_PAGE_SIZE = 50
const PAGE_SIZES = [25, 50, 100, 250]

export type ReportPagerProps = {
  total: number
  page: number
  pageSize: number
  onPage: (page: number) => void
  onPageSize: (pageSize: number) => void
}

export default function ReportPager({ total, page, pageSize, onPage, onPageSize }: ReportPagerProps) {
  const t = useT()
  const lastPage = Math.max(0, Math.ceil(total / pageSize) - 1)
  const from = total === 0 ? 0 : page * pageSize + 1
  const to = Math.min(total, (page + 1) * pageSize)

  return (
    <div
      data-testid="report-pager"
      style={{ display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: 10 }}
    >
      <span className="lead" style={{ fontSize: 13 }}>{t('reports.pager.showing', { from, to, total })}</span>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13 }}>
          {t('reports.pager.rows')}
          <select value={pageSize} onChange={(event) => onPageSize(Number(event.target.value))}>
            {PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
          </select>
        </label>
        <button type="button" disabled={page <= 0} onClick={() => onPage(page - 1)}>{t('reports.pager.previous')}</button>
        <button type="button" disabled={page >= lastPage} onClick={() => onPage(page + 1)}>{t('reports.pager.next')}</button>
      </div>
    </div>
  )
}
